// prop-types is a library for typechecking of props
import PropTypes from "prop-types";
import { Link } from "react-router-dom";

// @mui material components
import Card from "@mui/material/Card";
import Divider from "@mui/material/Divider";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";

function ComplexStatisticsCard({
  height,
  color,
  title,
  mypoint,
  onClick,
  pointBrand,
  points,
  minRedeemPoints,
  maxRedeemPoints,
  bottomLeft,
  bottomRight,
  pointsData,
  isLink,
  link,
}) {
  return (
    <div className="bg-white rounded-xl p-4 w-full max-w-md shadow-sm">
      <MDBox display="flex">
        <MDBox
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <div className="bg-purple-100 w-12 h-12 rounded-full p-3 mr-3">
            {pointBrand && <MDBox component="img" src={pointBrand} alt="pointBrand" />}
          </div>

          {mypoint && (
            <MDTypography variant="button" fontWeight="light" color="text">
              {"Minimum redemption - "}
              {minRedeemPoints}
            </MDTypography>
          )}
        </MDBox>

        {mypoint ? (
          <>
            <MDBox sx={{ display: "flex", flexDirection: "column", gap: 1, pt: 3 }}>
              <MDTypography textAlign="center" variant="button" fontWeight="bold" color="text">
                Available points
              </MDTypography>
              <MDBox
                color="white"
                bgColor="success"
                variant="gradient"
                borderRadius="lg"
                shadow="lg"
                opacity={1}
                py={1}
                gap={1}
                sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}
              >
                <MDBox component="img" src={pointBrand} alt="pointBrand" width="1.5rem" />
                <MDTypography variant="button" fontWeight="bold" color="white">
                  {points}
                </MDTypography>
              </MDBox>
            </MDBox>
            <MDBox textAlign="right" sx={{ display: "flex", alignItems: "end" }}>
              <MDTypography variant="button" fontWeight="light" color="text">
                {title}
                {maxRedeemPoints}
              </MDTypography>
            </MDBox>
          </>
        ) : (
          <div className="flex flex-col">
            <span className="text-gray-800 font-medium text-base">{title}</span>

            <div className="mb-[14px]">
              <h2 className="text-2xl font-semibold text-gray-900">{pointsData}</h2>
            </div>
          </div>
        )}
      </MDBox>
      <Divider />
      <MDBox
        px={1}
        pb={1.5}
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          flexDirection: "row",
        }}
      >
        {bottomLeft && (
          <MDTypography p={0.75} variant="button" color="text">
            {bottomLeft}
          </MDTypography>
        )}

        {bottomRight &&
          (mypoint ? (
            <MDButton
              variant="gradient"
              color={"info"}
              size="medium"
              disabled={!points}
              onClick={() => {
                onClick();
              }}
            >
              {bottomRight}
            </MDButton>
          ) : (
            <Link to={link ? link : ""}>
              <MDButton
                variant="text"
                color={"info"}
                size="small"
                onClick={() => onClick}
                style={
                  link
                    ? { textDecoration: "underline", cursor: "pointer" }
                    : { cursor: "auto", padding: "0px" }
                }
              >
                {bottomRight}
              </MDButton>
            </Link>
          ))}
      </MDBox>
    </div>
  );
}

// Setting default values for the props of ComplexStatisticsCard
ComplexStatisticsCard.defaultProps = {
  color: "info",
  percentage: {
    color: "success",
    text: "",
    label: "",
  },
};

// Typechecking props for the ComplexStatisticsCard
ComplexStatisticsCard.propTypes = {
  color: PropTypes.oneOf([
    "primary",
    "secondary",
    "info",
    "success",
    "warning",
    "error",
    "light",
    "dark",
  ]),
  title: PropTypes.string.isRequired,
  count: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  percentage: PropTypes.shape({
    color: PropTypes.oneOf([
      "primary",
      "secondary",
      "info",
      "success",
      "warning",
      "error",
      "dark",
      "white",
    ]),
    amount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    label: PropTypes.string,
  }),
  bottomLeft: PropTypes.string,
  bottomRight: PropTypes.string,
  mypoint: PropTypes.bool,
  onClick: PropTypes.func,
  pointBrand: PropTypes.any,
  points: PropTypes.string,
  minRedeemPoints: PropTypes.number,
  maxRedeemPoints: PropTypes.number,
  pointsData: PropTypes.number,
  isLink: PropTypes.bool,
  link: PropTypes.string,
  height: PropTypes.string,
};

export default ComplexStatisticsCard;
